import * as React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'

function SvgPatternShapes(props) {
	return (
		<SvgIcon {...props}>
			<path
				d="M3.4 20.6V3.4h17.2v17.2H3.4zm16-16H4.6v14.8h2.074L19.399 6.675 19.4 4.6zm-.076 3.849L8.374 19.4h4.3l6.65-6.65V8.449zm0 6l-4.95 4.951h4.95v-4.951zM9 5.4a3.6 3.6 0 110 7.2 3.6 3.6 0 010-7.2zm0 1.2a2.4 2.4 0 100 4.8 2.4 2.4 0 000-4.8z"
				fill="currentColor"
				fillRule="nonzero"
			/>
		</SvgIcon>
	)
}

export default SvgPatternShapes
